// AUTO-GENERATED tutorial fixtures — sanitized captures of the REAL backend
// rules/positioning engine driven locally in the backend test environment
// (curated deterministic deal; every payload below is the authentic
// game_state_for_user shape the production REST/WS pipeline delivers).
// Sanitized: synthetic ids (game 9001 / session 9002 / users 101-104 /
// value-based tile ids), synthetic identities, unused subtrees emptied.
// Do NOT hand-edit geometry or engine_data — regenerate from a fresh local
// capture instead (see the tutorial feature notes).
import type { FullGameStateForUser } from '../../types/game';

export const TUTORIAL_GAME_ID = 9001;
export const TUTORIAL_SESSION_ID = 9002;
export const TUTORIAL_MY_USER_ID = 101;

/** Tile ids are value-based: 700 + max(a,b)*7 + min(a,b). */
export const tutorialTileId = (a: number, b: number): number =>
  700 + Math.max(a, b) * 7 + Math.min(a, b);

export interface TutorialTimeline {
  /** s0 — boot: empty board, my turn, only 6|6 playable. */
  boot: FullGameStateForUser;
  /** s1 — confirmation of my 6|6 opening. */
  afterOpen: FullGameStateForUser;
  /** s2..s4 — three scripted bot replies; last one is my lesson-2 turn. */
  botReplies1: FullGameStateForUser[];
  /** s5 — confirmation of my 3|0 match. */
  afterMatch: FullGameStateForUser;
  /** s6..s8 — three scripted bot replies; last one is my lesson-3 turn. */
  botReplies2: FullGameStateForUser[];
  /** s9 — my 5|0 played on the LEFT end. */
  finalLeft: FullGameStateForUser;
  /** s9 — my 5|0 played on the RIGHT end. */
  finalRight: FullGameStateForUser;
}

export const TUTORIAL_TIMELINE: TutorialTimeline = {
  "boot": {
    "id": 9001,
    "state_seq": 0,
    "status": "active",
    "game_mode": "bots",
    "current_turn": 0,
    "current_turn_user_id": 101,
    "current_turn_team": 0,
    "board_left_end": null,
    "board_right_end": null,
    "played_tiles": [],
    "my_hand": [
      {
        "id": 748,
        "value_a": 6,
        "value_b": 6,
        "is_double": true,
        "valid_positions": [
          {
            "side": "left",
            "end_id": 0,
            "x": 0.0,
            "y": 0.0,
            "orientation": "horizontal",
            "engine_data": {}
          }
        ]
      },
      {
        "id": 721,
        "value_a": 3,
        "value_b": 0,
        "is_double": false,
        "valid_positions": []
      },
      {
        "id": 735,
        "value_a": 5,
        "value_b": 0,
        "is_double": false,
        "valid_positions": []
      },
      {
        "id": 730,
        "value_a": 2,
        "value_b": 4,
        "is_double": false,
        "valid_positions": []
      },
      {
        "id": 744,
        "value_a": 2,
        "value_b": 6,
        "is_double": false,
        "valid_positions": []
      },
      {
        "id": 746,
        "value_a": 4,
        "value_b": 6,
        "is_double": false,
        "valid_positions": []
      },
      {
        "id": 716,
        "value_a": 2,
        "value_b": 2,
        "is_double": true,
        "valid_positions": []
      }
    ],
    "my_team": 0,
    "my_position": 0,
    "viewer_cosmetics": {
      "table_skin": "green_fabric",
      "tile_skin": "classic"
    },
    "winner_team": null,
    "game_end_type": null,
    "session_id": 9002,
    "game_number": 1,
    "starting_player_position": 0,
    "starting_player_user_id": 101,
    "board_layout": {
      "board_config": {
        "min_x": -6,
        "max_x": 6,
        "min_y": -7,
        "max_y": 7,
        "tile_width": 2,
        "tile_height": 1
      },
      "tiles": [],
      "board_ends": [],
      "chain_length": 0
    },
    "board_chain_length": 0,
    "players": [
      {
        "id": 101,
        "display_name": "You",
        "country_code": null,
        "avatar_key": null,
        "avatar_url": null,
        "is_bot": false,
        "team": 0,
        "position": 0
      },
      {
        "id": 102,
        "display_name": "Bot (Medium)",
        "country_code": null,
        "avatar_key": "avatar_1",
        "avatar_url": null,
        "is_bot": true,
        "team": 1,
        "position": 1
      },
      {
        "id": 103,
        "display_name": "Bot (Medium)",
        "country_code": null,
        "avatar_key": "avatar_2",
        "avatar_url": null,
        "is_bot": true,
        "team": 0,
        "position": 2
      },
      {
        "id": 104,
        "display_name": "Bot (Medium)",
        "country_code": null,
        "avatar_key": "avatar_3",
        "avatar_url": null,
        "is_bot": true,
        "team": 1,
        "position": 3
      }
    ],
    "hand_counts": {
      "0": 7,
      "1": 7,
      "2": 7,
      "3": 7
    },
    "session_team_scores": {
      "0": 0,
      "1": 0
    },
    "next_round_deadline_at": null,
    "next_round_ready": null,
    "next_game_id": null,
    "session_over": false,
    "session_winner_team": null,
    "session_completion_reason": null,
    "target_score": 100,
    "rematch": null
  },
  "afterOpen": {
    "id": 9001,
    "state_seq": 1,
    "status": "active",
    "game_mode": "bots",
    "current_turn": 1,
    "current_turn_user_id": 102,
    "current_turn_team": 1,
    "board_left_end": 6,
    "board_right_end": 6,
    "played_tiles": [],
    "my_hand": [
      {
        "id": 721,
        "value_a": 3,
        "value_b": 0,
        "is_double": false,
        "valid_positions": []
      },
      {
        "id": 735,
        "value_a": 5,
        "value_b": 0,
        "is_double": false,
        "valid_positions": []
      },
      {
        "id": 730,
        "value_a": 2,
        "value_b": 4,
        "is_double": false,
        "valid_positions": []
      },
      {
        "id": 744,
        "value_a": 2,
        "value_b": 6,
        "is_double": false,
        "valid_positions": [
          {
            "side": "left",
            "end_id": 2,
            "x": 0.0,
            "y": -1.5,
            "orientation": "vertical",
            "engine_data": {
              "a": 2,
              "b": 6,
              "ndir": "down",
              "near_val": 6,
              "far_val": 2,
              "double": false,
              "center": [
                0.0,
                -1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "side": "right",
            "end_id": 3,
            "x": 0.0,
            "y": 1.5,
            "orientation": "vertical",
            "engine_data": {
              "a": 2,
              "b": 6,
              "ndir": "up",
              "near_val": 6,
              "far_val": 2,
              "double": false,
              "center": [
                0.0,
                1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          }
        ]
      },
      {
        "id": 746,
        "value_a": 4,
        "value_b": 6,
        "is_double": false,
        "valid_positions": [
          {
            "side": "left",
            "end_id": 2,
            "x": 0.0,
            "y": -1.5,
            "orientation": "vertical",
            "engine_data": {
              "a": 4,
              "b": 6,
              "ndir": "down",
              "near_val": 6,
              "far_val": 4,
              "double": false,
              "center": [
                0.0,
                -1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "side": "right",
            "end_id": 3,
            "x": 0.0,
            "y": 1.5,
            "orientation": "vertical",
            "engine_data": {
              "a": 4,
              "b": 6,
              "ndir": "up",
              "near_val": 6,
              "far_val": 4,
              "double": false,
              "center": [
                0.0,
                1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          }
        ]
      },
      {
        "id": 716,
        "value_a": 2,
        "value_b": 2,
        "is_double": true,
        "valid_positions": []
      }
    ],
    "my_team": 0,
    "my_position": 0,
    "viewer_cosmetics": {
      "table_skin": "green_fabric",
      "tile_skin": "classic"
    },
    "winner_team": null,
    "game_end_type": null,
    "session_id": 9002,
    "game_number": 1,
    "starting_player_position": 0,
    "starting_player_user_id": 101,
    "board_layout": {
      "board_config": {
        "min_x": -6,
        "max_x": 6,
        "min_y": -7,
        "max_y": 7,
        "tile_width": 2,
        "tile_height": 1
      },
      "tiles": [
        {
          "id": 748,
          "value_a": 6,
          "value_b": 6,
          "position": {
            "x": 0.0,
            "y": 0.0,
            "orientation": "horizontal",
            "connected_side": "a"
          },
          "connected_side": "a",
          "is_double": false,
          "engine_data": {
            "a": 6,
            "b": 6,
            "ndir": "right",
            "near_val": 6,
            "far_val": 6,
            "double": false,
            "center": [
              0.0,
              0.0
            ],
            "horizontal": true,
            "cross_horizontal": false
          }
        }
      ],
      "board_ends": [],
      "chain_length": 1
    },
    "board_chain_length": 1,
    "players": [
      {
        "id": 101,
        "display_name": "You",
        "country_code": null,
        "avatar_key": null,
        "avatar_url": null,
        "is_bot": false,
        "team": 0,
        "position": 0
      },
      {
        "id": 102,
        "display_name": "Bot (Medium)",
        "country_code": null,
        "avatar_key": "avatar_1",
        "avatar_url": null,
        "is_bot": true,
        "team": 1,
        "position": 1
      },
      {
        "id": 103,
        "display_name": "Bot (Medium)",
        "country_code": null,
        "avatar_key": "avatar_2",
        "avatar_url": null,
        "is_bot": true,
        "team": 0,
        "position": 2
      },
      {
        "id": 104,
        "display_name": "Bot (Medium)",
        "country_code": null,
        "avatar_key": "avatar_3",
        "avatar_url": null,
        "is_bot": true,
        "team": 1,
        "position": 3
      }
    ],
    "hand_counts": {
      "0": 6,
      "1": 7,
      "2": 7,
      "3": 7
    },
    "session_team_scores": {
      "0": 0,
      "1": 0
    },
    "next_round_deadline_at": null,
    "next_round_ready": null,
    "next_game_id": null,
    "session_over": false,
    "session_winner_team": null,
    "session_completion_reason": null,
    "target_score": 100,
    "rematch": null
  },
  "botReplies1": [
    {
      "id": 9001,
      "state_seq": 2,
      "status": "active",
      "game_mode": "bots",
      "current_turn": 2,
      "current_turn_user_id": 103,
      "current_turn_team": 0,
      "board_left_end": 3,
      "board_right_end": 6,
      "played_tiles": [],
      "my_hand": [
        {
          "id": 721,
          "value_a": 3,
          "value_b": 0,
          "is_double": false,
          "valid_positions": [
            {
              "side": "left",
              "end_id": 4,
              "x": 0.0,
              "y": -3.5,
              "orientation": "vertical",
              "engine_data": {
                "a": 3,
                "b": 0,
                "ndir": "down",
                "near_val": 3,
                "far_val": 0,
                "double": false,
                "center": [
                  0.0,
                  -3.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            }
          ]
        },
        {
          "id": 735,
          "value_a": 5,
          "value_b": 0,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 730,
          "value_a": 2,
          "value_b": 4,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 744,
          "value_a": 2,
          "value_b": 6,
          "is_double": false,
          "valid_positions": [
            {
              "side": "right",
              "end_id": 3,
              "x": 0.0,
              "y": 1.5,
              "orientation": "vertical",
              "engine_data": {
                "a": 2,
                "b": 6,
                "ndir": "up",
                "near_val": 6,
                "far_val": 2,
                "double": false,
                "center": [
                  0.0,
                  1.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            }
          ]
        },
        {
          "id": 746,
          "value_a": 4,
          "value_b": 6,
          "is_double": false,
          "valid_positions": [
            {
              "side": "right",
              "end_id": 3,
              "x": 0.0,
              "y": 1.5,
              "orientation": "vertical",
              "engine_data": {
                "a": 4,
                "b": 6,
                "ndir": "up",
                "near_val": 6,
                "far_val": 4,
                "double": false,
                "center": [
                  0.0,
                  1.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            }
          ]
        },
        {
          "id": 716,
          "value_a": 2,
          "value_b": 2,
          "is_double": true,
          "valid_positions": []
        }
      ],
      "my_team": 0,
      "my_position": 0,
      "viewer_cosmetics": {
        "table_skin": "green_fabric",
        "tile_skin": "classic"
      },
      "winner_team": null,
      "game_end_type": null,
      "session_id": 9002,
      "game_number": 1,
      "starting_player_position": 0,
      "starting_player_user_id": 101,
      "board_layout": {
        "board_config": {
          "min_x": -6,
          "max_x": 6,
          "min_y": -7,
          "max_y": 7,
          "tile_width": 2,
          "tile_height": 1
        },
        "tiles": [
          {
            "id": 748,
            "value_a": 6,
            "value_b": 6,
            "position": {
              "x": 0.0,
              "y": 0.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 6,
              "ndir": "right",
              "near_val": 6,
              "far_val": 6,
              "double": false,
              "center": [
                0.0,
                0.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 745,
            "value_a": 6,
            "value_b": 3,
            "position": {
              "x": 0.0,
              "y": -1.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 3,
              "ndir": "down",
              "near_val": 6,
              "far_val": 3,
              "double": false,
              "center": [
                0.0,
                -1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          }
        ],
        "board_ends": [],
        "chain_length": 2
      },
      "board_chain_length": 2,
      "players": [
        {
          "id": 101,
          "display_name": "You",
          "country_code": null,
          "avatar_key": null,
          "avatar_url": null,
          "is_bot": false,
          "team": 0,
          "position": 0
        },
        {
          "id": 102,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_1",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 1
        },
        {
          "id": 103,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_2",
          "avatar_url": null,
          "is_bot": true,
          "team": 0,
          "position": 2
        },
        {
          "id": 104,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_3",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 3
        }
      ],
      "hand_counts": {
        "0": 6,
        "1": 6,
        "2": 7,
        "3": 7
      },
      "session_team_scores": {
        "0": 0,
        "1": 0
      },
      "next_round_deadline_at": null,
      "next_round_ready": null,
      "next_game_id": null,
      "session_over": false,
      "session_winner_team": null,
      "session_completion_reason": null,
      "target_score": 100,
      "rematch": null
    },
    {
      "id": 9001,
      "state_seq": 3,
      "status": "active",
      "game_mode": "bots",
      "current_turn": 3,
      "current_turn_user_id": 104,
      "current_turn_team": 1,
      "board_left_end": 3,
      "board_right_end": 1,
      "played_tiles": [],
      "my_hand": [
        {
          "id": 721,
          "value_a": 3,
          "value_b": 0,
          "is_double": false,
          "valid_positions": [
            {
              "side": "left",
              "end_id": 4,
              "x": 0.0,
              "y": -3.5,
              "orientation": "vertical",
              "engine_data": {
                "a": 3,
                "b": 0,
                "ndir": "down",
                "near_val": 3,
                "far_val": 0,
                "double": false,
                "center": [
                  0.0,
                  -3.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            }
          ]
        },
        {
          "id": 735,
          "value_a": 5,
          "value_b": 0,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 730,
          "value_a": 2,
          "value_b": 4,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 744,
          "value_a": 2,
          "value_b": 6,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 746,
          "value_a": 4,
          "value_b": 6,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 716,
          "value_a": 2,
          "value_b": 2,
          "is_double": true,
          "valid_positions": []
        }
      ],
      "my_team": 0,
      "my_position": 0,
      "viewer_cosmetics": {
        "table_skin": "green_fabric",
        "tile_skin": "classic"
      },
      "winner_team": null,
      "game_end_type": null,
      "session_id": 9002,
      "game_number": 1,
      "starting_player_position": 0,
      "starting_player_user_id": 101,
      "board_layout": {
        "board_config": {
          "min_x": -6,
          "max_x": 6,
          "min_y": -7,
          "max_y": 7,
          "tile_width": 2,
          "tile_height": 1
        },
        "tiles": [
          {
            "id": 748,
            "value_a": 6,
            "value_b": 6,
            "position": {
              "x": 0.0,
              "y": 0.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 6,
              "ndir": "right",
              "near_val": 6,
              "far_val": 6,
              "double": false,
              "center": [
                0.0,
                0.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 745,
            "value_a": 6,
            "value_b": 3,
            "position": {
              "x": 0.0,
              "y": -1.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 3,
              "ndir": "down",
              "near_val": 6,
              "far_val": 3,
              "double": false,
              "center": [
                0.0,
                -1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 743,
            "value_a": 6,
            "value_b": 1,
            "position": {
              "x": 0.0,
              "y": 1.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 1,
              "ndir": "up",
              "near_val": 6,
              "far_val": 1,
              "double": false,
              "center": [
                0.0,
                1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          }
        ],
        "board_ends": [],
        "chain_length": 3
      },
      "board_chain_length": 3,
      "players": [
        {
          "id": 101,
          "display_name": "You",
          "country_code": null,
          "avatar_key": null,
          "avatar_url": null,
          "is_bot": false,
          "team": 0,
          "position": 0
        },
        {
          "id": 102,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_1",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 1
        },
        {
          "id": 103,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_2",
          "avatar_url": null,
          "is_bot": true,
          "team": 0,
          "position": 2
        },
        {
          "id": 104,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_3",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 3
        }
      ],
      "hand_counts": {
        "0": 6,
        "1": 6,
        "2": 6,
        "3": 7
      },
      "session_team_scores": {
        "0": 0,
        "1": 0
      },
      "next_round_deadline_at": null,
      "next_round_ready": null,
      "next_game_id": null,
      "session_over": false,
      "session_winner_team": null,
      "session_completion_reason": null,
      "target_score": 100,
      "rematch": null
    },
    {
      "id": 9001,
      "state_seq": 4,
      "status": "active",
      "game_mode": "bots",
      "current_turn": 0,
      "current_turn_user_id": 101,
      "current_turn_team": 0,
      "board_left_end": 3,
      "board_right_end": 1,
      "played_tiles": [],
      "my_hand": [
        {
          "id": 721,
          "value_a": 3,
          "value_b": 0,
          "is_double": false,
          "valid_positions": [
            {
              "side": "left",
              "end_id": 6,
              "x": 0.0,
              "y": -4.5,
              "orientation": "vertical",
              "engine_data": {
                "a": 3,
                "b": 0,
                "ndir": "down",
                "near_val": 3,
                "far_val": 0,
                "double": false,
                "center": [
                  0.0,
                  -4.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            }
          ]
        },
        {
          "id": 735,
          "value_a": 5,
          "value_b": 0,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 730,
          "value_a": 2,
          "value_b": 4,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 744,
          "value_a": 2,
          "value_b": 6,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 746,
          "value_a": 4,
          "value_b": 6,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 716,
          "value_a": 2,
          "value_b": 2,
          "is_double": true,
          "valid_positions": []
        }
      ],
      "my_team": 0,
      "my_position": 0,
      "viewer_cosmetics": {
        "table_skin": "green_fabric",
        "tile_skin": "classic"
      },
      "winner_team": null,
      "game_end_type": null,
      "session_id": 9002,
      "game_number": 1,
      "starting_player_position": 0,
      "starting_player_user_id": 101,
      "board_layout": {
        "board_config": {
          "min_x": -6,
          "max_x": 6,
          "min_y": -7,
          "max_y": 7,
          "tile_width": 2,
          "tile_height": 1
        },
        "tiles": [
          {
            "id": 748,
            "value_a": 6,
            "value_b": 6,
            "position": {
              "x": 0.0,
              "y": 0.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 6,
              "ndir": "right",
              "near_val": 6,
              "far_val": 6,
              "double": false,
              "center": [
                0.0,
                0.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 745,
            "value_a": 6,
            "value_b": 3,
            "position": {
              "x": 0.0,
              "y": -1.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 3,
              "ndir": "down",
              "near_val": 6,
              "far_val": 3,
              "double": false,
              "center": [
                0.0,
                -1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 743,
            "value_a": 6,
            "value_b": 1,
            "position": {
              "x": 0.0,
              "y": 1.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 1,
              "ndir": "up",
              "near_val": 6,
              "far_val": 1,
              "double": false,
              "center": [
                0.0,
                1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 724,
            "value_a": 3,
            "value_b": 3,
            "position": {
              "x": 0.0,
              "y": -3.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 3,
              "b": 3,
              "ndir": "down",
              "near_val": 3,
              "far_val": 3,
              "double": false,
              "center": [
                0.0,
                -3.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          }
        ],
        "board_ends": [],
        "chain_length": 4
      },
      "board_chain_length": 4,
      "players": [
        {
          "id": 101,
          "display_name": "You",
          "country_code": null,
          "avatar_key": null,
          "avatar_url": null,
          "is_bot": false,
          "team": 0,
          "position": 0
        },
        {
          "id": 102,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_1",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 1
        },
        {
          "id": 103,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_2",
          "avatar_url": null,
          "is_bot": true,
          "team": 0,
          "position": 2
        },
        {
          "id": 104,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_3",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 3
        }
      ],
      "hand_counts": {
        "0": 6,
        "1": 6,
        "2": 6,
        "3": 6
      },
      "session_team_scores": {
        "0": 0,
        "1": 0
      },
      "next_round_deadline_at": null,
      "next_round_ready": null,
      "next_game_id": null,
      "session_over": false,
      "session_winner_team": null,
      "session_completion_reason": null,
      "target_score": 100,
      "rematch": null
    }
  ],
  "afterMatch": {
    "id": 9001,
    "state_seq": 5,
    "status": "active",
    "game_mode": "bots",
    "current_turn": 1,
    "current_turn_user_id": 102,
    "current_turn_team": 1,
    "board_left_end": 0,
    "board_right_end": 1,
    "played_tiles": [],
    "my_hand": [
      {
        "id": 735,
        "value_a": 5,
        "value_b": 0,
        "is_double": false,
        "valid_positions": [
          {
            "side": "left",
            "end_id": 7,
            "x": 0.0,
            "y": -6.5,
            "orientation": "vertical",
            "engine_data": {
              "a": 5,
              "b": 0,
              "ndir": "down",
              "near_val": 0,
              "far_val": 5,
              "double": false,
              "center": [
                0.0,
                -6.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          }
        ]
      },
      {
        "id": 730,
        "value_a": 2,
        "value_b": 4,
        "is_double": false,
        "valid_positions": []
      },
      {
        "id": 744,
        "value_a": 2,
        "value_b": 6,
        "is_double": false,
        "valid_positions": []
      },
      {
        "id": 746,
        "value_a": 4,
        "value_b": 6,
        "is_double": false,
        "valid_positions": []
      },
      {
        "id": 716,
        "value_a": 2,
        "value_b": 2,
        "is_double": true,
        "valid_positions": []
      }
    ],
    "my_team": 0,
    "my_position": 0,
    "viewer_cosmetics": {
      "table_skin": "green_fabric",
      "tile_skin": "classic"
    },
    "winner_team": null,
    "game_end_type": null,
    "session_id": 9002,
    "game_number": 1,
    "starting_player_position": 0,
    "starting_player_user_id": 101,
    "board_layout": {
      "board_config": {
        "min_x": -6,
        "max_x": 6,
        "min_y": -7,
        "max_y": 7,
        "tile_width": 2,
        "tile_height": 1
      },
      "tiles": [
        {
          "id": 748,
          "value_a": 6,
          "value_b": 6,
          "position": {
            "x": 0.0,
            "y": 0.0,
            "orientation": "horizontal",
            "connected_side": "a"
          },
          "connected_side": "a",
          "is_double": false,
          "engine_data": {
            "a": 6,
            "b": 6,
            "ndir": "right",
            "near_val": 6,
            "far_val": 6,
            "double": false,
            "center": [
              0.0,
              0.0
            ],
            "horizontal": true,
            "cross_horizontal": false
          }
        },
        {
          "id": 745,
          "value_a": 6,
          "value_b": 3,
          "position": {
            "x": 0.0,
            "y": -1.5,
            "orientation": "vertical",
            "connected_side": "a"
          },
          "connected_side": "a",
          "is_double": false,
          "engine_data": {
            "a": 6,
            "b": 3,
            "ndir": "down",
            "near_val": 6,
            "far_val": 3,
            "double": false,
            "center": [
              0.0,
              -1.5
            ],
            "horizontal": false,
            "cross_horizontal": false
          }
        },
        {
          "id": 743,
          "value_a": 6,
          "value_b": 1,
          "position": {
            "x": 0.0,
            "y": 1.5,
            "orientation": "vertical",
            "connected_side": "a"
          },
          "connected_side": "a",
          "is_double": false,
          "engine_data": {
            "a": 6,
            "b": 1,
            "ndir": "up",
            "near_val": 6,
            "far_val": 1,
            "double": false,
            "center": [
              0.0,
              1.5
            ],
            "horizontal": false,
            "cross_horizontal": false
          }
        },
        {
          "id": 724,
          "value_a": 3,
          "value_b": 3,
          "position": {
            "x": 0.0,
            "y": -3.0,
            "orientation": "horizontal",
            "connected_side": "a"
          },
          "connected_side": "a",
          "is_double": false,
          "engine_data": {
            "a": 3,
            "b": 3,
            "ndir": "down",
            "near_val": 3,
            "far_val": 3,
            "double": false,
            "center": [
              0.0,
              -3.0
            ],
            "horizontal": true,
            "cross_horizontal": false
          }
        },
        {
          "id": 721,
          "value_a": 3,
          "value_b": 0,
          "position": {
            "x": 0.0,
            "y": -4.5,
            "orientation": "vertical",
            "connected_side": "a"
          },
          "connected_side": "a",
          "is_double": false,
          "engine_data": {
            "a": 3,
            "b": 0,
            "ndir": "down",
            "near_val": 3,
            "far_val": 0,
            "double": false,
            "center": [
              0.0,
              -4.5
            ],
            "horizontal": false,
            "cross_horizontal": false
          }
        }
      ],
      "board_ends": [],
      "chain_length": 5
    },
    "board_chain_length": 5,
    "players": [
      {
        "id": 101,
        "display_name": "You",
        "country_code": null,
        "avatar_key": null,
        "avatar_url": null,
        "is_bot": false,
        "team": 0,
        "position": 0
      },
      {
        "id": 102,
        "display_name": "Bot (Medium)",
        "country_code": null,
        "avatar_key": "avatar_1",
        "avatar_url": null,
        "is_bot": true,
        "team": 1,
        "position": 1
      },
      {
        "id": 103,
        "display_name": "Bot (Medium)",
        "country_code": null,
        "avatar_key": "avatar_2",
        "avatar_url": null,
        "is_bot": true,
        "team": 0,
        "position": 2
      },
      {
        "id": 104,
        "display_name": "Bot (Medium)",
        "country_code": null,
        "avatar_key": "avatar_3",
        "avatar_url": null,
        "is_bot": true,
        "team": 1,
        "position": 3
      }
    ],
    "hand_counts": {
      "0": 5,
      "1": 6,
      "2": 6,
      "3": 6
    },
    "session_team_scores": {
      "0": 0,
      "1": 0
    },
    "next_round_deadline_at": null,
    "next_round_ready": null,
    "next_game_id": null,
    "session_over": false,
    "session_winner_team": null,
    "session_completion_reason": null,
    "target_score": 100,
    "rematch": null
  },
  "botReplies2": [
    {
      "id": 9001,
      "state_seq": 6,
      "status": "active",
      "game_mode": "bots",
      "current_turn": 2,
      "current_turn_user_id": 103,
      "current_turn_team": 0,
      "board_left_end": 0,
      "board_right_end": 5,
      "played_tiles": [],
      "my_hand": [
        {
          "id": 735,
          "value_a": 5,
          "value_b": 0,
          "is_double": false,
          "valid_positions": [
            {
              "side": "left",
              "end_id": 7,
              "x": 0.0,
              "y": -6.5,
              "orientation": "vertical",
              "engine_data": {
                "a": 5,
                "b": 0,
                "ndir": "down",
                "near_val": 0,
                "far_val": 5,
                "double": false,
                "center": [
                  0.0,
                  -6.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "side": "right",
              "end_id": 8,
              "x": 0.0,
              "y": 5.5,
              "orientation": "vertical",
              "engine_data": {
                "a": 5,
                "b": 0,
                "ndir": "up",
                "near_val": 5,
                "far_val": 0,
                "double": false,
                "center": [
                  0.0,
                  5.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            }
          ]
        },
        {
          "id": 730,
          "value_a": 2,
          "value_b": 4,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 744,
          "value_a": 2,
          "value_b": 6,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 746,
          "value_a": 4,
          "value_b": 6,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 716,
          "value_a": 2,
          "value_b": 2,
          "is_double": true,
          "valid_positions": []
        }
      ],
      "my_team": 0,
      "my_position": 0,
      "viewer_cosmetics": {
        "table_skin": "green_fabric",
        "tile_skin": "classic"
      },
      "winner_team": null,
      "game_end_type": null,
      "session_id": 9002,
      "game_number": 1,
      "starting_player_position": 0,
      "starting_player_user_id": 101,
      "board_layout": {
        "board_config": {
          "min_x": -6,
          "max_x": 6,
          "min_y": -7,
          "max_y": 7,
          "tile_width": 2,
          "tile_height": 1
        },
        "tiles": [
          {
            "id": 748,
            "value_a": 6,
            "value_b": 6,
            "position": {
              "x": 0.0,
              "y": 0.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 6,
              "ndir": "right",
              "near_val": 6,
              "far_val": 6,
              "double": false,
              "center": [
                0.0,
                0.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 745,
            "value_a": 6,
            "value_b": 3,
            "position": {
              "x": 0.0,
              "y": -1.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 3,
              "ndir": "down",
              "near_val": 6,
              "far_val": 3,
              "double": false,
              "center": [
                0.0,
                -1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 743,
            "value_a": 6,
            "value_b": 1,
            "position": {
              "x": 0.0,
              "y": 1.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 1,
              "ndir": "up",
              "near_val": 6,
              "far_val": 1,
              "double": false,
              "center": [
                0.0,
                1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 724,
            "value_a": 3,
            "value_b": 3,
            "position": {
              "x": 0.0,
              "y": -3.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 3,
              "b": 3,
              "ndir": "down",
              "near_val": 3,
              "far_val": 3,
              "double": false,
              "center": [
                0.0,
                -3.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 721,
            "value_a": 3,
            "value_b": 0,
            "position": {
              "x": 0.0,
              "y": -4.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 3,
              "b": 0,
              "ndir": "down",
              "near_val": 3,
              "far_val": 0,
              "double": false,
              "center": [
                0.0,
                -4.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 736,
            "value_a": 5,
            "value_b": 1,
            "position": {
              "x": 0.0,
              "y": 3.5,
              "orientation": "vertical",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 5,
              "b": 1,
              "ndir": "up",
              "near_val": 1,
              "far_val": 5,
              "double": false,
              "center": [
                0.0,
                3.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          }
        ],
        "board_ends": [],
        "chain_length": 6
      },
      "board_chain_length": 6,
      "players": [
        {
          "id": 101,
          "display_name": "You",
          "country_code": null,
          "avatar_key": null,
          "avatar_url": null,
          "is_bot": false,
          "team": 0,
          "position": 0
        },
        {
          "id": 102,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_1",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 1
        },
        {
          "id": 103,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_2",
          "avatar_url": null,
          "is_bot": true,
          "team": 0,
          "position": 2
        },
        {
          "id": 104,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_3",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 3
        }
      ],
      "hand_counts": {
        "0": 5,
        "1": 5,
        "2": 6,
        "3": 6
      },
      "session_team_scores": {
        "0": 0,
        "1": 0
      },
      "next_round_deadline_at": null,
      "next_round_ready": null,
      "next_game_id": null,
      "session_over": false,
      "session_winner_team": null,
      "session_completion_reason": null,
      "target_score": 100,
      "rematch": null
    },
    {
      "id": 9001,
      "state_seq": 7,
      "status": "active",
      "game_mode": "bots",
      "current_turn": 3,
      "current_turn_user_id": 104,
      "current_turn_team": 1,
      "board_left_end": 0,
      "board_right_end": 5,
      "played_tiles": [],
      "my_hand": [
        {
          "id": 735,
          "value_a": 5,
          "value_b": 0,
          "is_double": false,
          "valid_positions": [
            {
              "side": "right",
              "end_id": 8,
              "x": 0.0,
              "y": 5.5,
              "orientation": "vertical",
              "engine_data": {
                "a": 5,
                "b": 0,
                "ndir": "up",
                "near_val": 5,
                "far_val": 0,
                "double": false,
                "center": [
                  0.0,
                  5.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "side": "left",
              "end_id": 9,
              "x": -2.0,
              "y": -6.0,
              "orientation": "horizontal",
              "engine_data": {
                "a": 5,
                "b": 0,
                "ndir": "left",
                "near_val": 0,
                "far_val": 5,
                "double": false,
                "center": [
                  -2.0,
                  -6.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            }
          ]
        },
        {
          "id": 730,
          "value_a": 2,
          "value_b": 4,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 744,
          "value_a": 2,
          "value_b": 6,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 746,
          "value_a": 4,
          "value_b": 6,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 716,
          "value_a": 2,
          "value_b": 2,
          "is_double": true,
          "valid_positions": []
        }
      ],
      "my_team": 0,
      "my_position": 0,
      "viewer_cosmetics": {
        "table_skin": "green_fabric",
        "tile_skin": "classic"
      },
      "winner_team": null,
      "game_end_type": null,
      "session_id": 9002,
      "game_number": 1,
      "starting_player_position": 0,
      "starting_player_user_id": 101,
      "board_layout": {
        "board_config": {
          "min_x": -6,
          "max_x": 6,
          "min_y": -7,
          "max_y": 7,
          "tile_width": 2,
          "tile_height": 1
        },
        "tiles": [
          {
            "id": 748,
            "value_a": 6,
            "value_b": 6,
            "position": {
              "x": 0.0,
              "y": 0.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 6,
              "ndir": "right",
              "near_val": 6,
              "far_val": 6,
              "double": false,
              "center": [
                0.0,
                0.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 745,
            "value_a": 6,
            "value_b": 3,
            "position": {
              "x": 0.0,
              "y": -1.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 3,
              "ndir": "down",
              "near_val": 6,
              "far_val": 3,
              "double": false,
              "center": [
                0.0,
                -1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 743,
            "value_a": 6,
            "value_b": 1,
            "position": {
              "x": 0.0,
              "y": 1.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 1,
              "ndir": "up",
              "near_val": 6,
              "far_val": 1,
              "double": false,
              "center": [
                0.0,
                1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 724,
            "value_a": 3,
            "value_b": 3,
            "position": {
              "x": 0.0,
              "y": -3.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 3,
              "b": 3,
              "ndir": "down",
              "near_val": 3,
              "far_val": 3,
              "double": false,
              "center": [
                0.0,
                -3.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 721,
            "value_a": 3,
            "value_b": 0,
            "position": {
              "x": 0.0,
              "y": -4.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 3,
              "b": 0,
              "ndir": "down",
              "near_val": 3,
              "far_val": 0,
              "double": false,
              "center": [
                0.0,
                -4.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 736,
            "value_a": 5,
            "value_b": 1,
            "position": {
              "x": 0.0,
              "y": 3.5,
              "orientation": "vertical",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 5,
              "b": 1,
              "ndir": "up",
              "near_val": 1,
              "far_val": 5,
              "double": false,
              "center": [
                0.0,
                3.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 700,
            "value_a": 0,
            "value_b": 0,
            "position": {
              "x": 0.0,
              "y": -6.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 0,
              "b": 0,
              "ndir": "down",
              "near_val": 0,
              "far_val": 0,
              "double": false,
              "center": [
                0.0,
                -6.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          }
        ],
        "board_ends": [],
        "chain_length": 7
      },
      "board_chain_length": 7,
      "players": [
        {
          "id": 101,
          "display_name": "You",
          "country_code": null,
          "avatar_key": null,
          "avatar_url": null,
          "is_bot": false,
          "team": 0,
          "position": 0
        },
        {
          "id": 102,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_1",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 1
        },
        {
          "id": 103,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_2",
          "avatar_url": null,
          "is_bot": true,
          "team": 0,
          "position": 2
        },
        {
          "id": 104,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_3",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 3
        }
      ],
      "hand_counts": {
        "0": 5,
        "1": 5,
        "2": 5,
        "3": 6
      },
      "session_team_scores": {
        "0": 0,
        "1": 0
      },
      "next_round_deadline_at": null,
      "next_round_ready": null,
      "next_game_id": null,
      "session_over": false,
      "session_winner_team": null,
      "session_completion_reason": null,
      "target_score": 100,
      "rematch": null
    },
    {
      "id": 9001,
      "state_seq": 8,
      "status": "active",
      "game_mode": "bots",
      "current_turn": 0,
      "current_turn_user_id": 101,
      "current_turn_team": 0,
      "board_left_end": 0,
      "board_right_end": 5,
      "played_tiles": [],
      "my_hand": [
        {
          "id": 735,
          "value_a": 5,
          "value_b": 0,
          "is_double": false,
          "valid_positions": [
            {
              "side": "left",
              "end_id": 9,
              "x": -2.0,
              "y": -6.0,
              "orientation": "horizontal",
              "engine_data": {
                "a": 5,
                "b": 0,
                "ndir": "left",
                "near_val": 0,
                "far_val": 5,
                "double": false,
                "center": [
                  -2.0,
                  -6.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "side": "right",
              "end_id": 10,
              "x": 2.0,
              "y": 5.0,
              "orientation": "horizontal",
              "engine_data": {
                "a": 5,
                "b": 0,
                "ndir": "right",
                "near_val": 5,
                "far_val": 0,
                "double": false,
                "center": [
                  2.0,
                  5.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            }
          ]
        },
        {
          "id": 730,
          "value_a": 2,
          "value_b": 4,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 744,
          "value_a": 2,
          "value_b": 6,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 746,
          "value_a": 4,
          "value_b": 6,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 716,
          "value_a": 2,
          "value_b": 2,
          "is_double": true,
          "valid_positions": []
        }
      ],
      "my_team": 0,
      "my_position": 0,
      "viewer_cosmetics": {
        "table_skin": "green_fabric",
        "tile_skin": "classic"
      },
      "winner_team": null,
      "game_end_type": null,
      "session_id": 9002,
      "game_number": 1,
      "starting_player_position": 0,
      "starting_player_user_id": 101,
      "board_layout": {
        "board_config": {
          "min_x": -6,
          "max_x": 6,
          "min_y": -7,
          "max_y": 7,
          "tile_width": 2,
          "tile_height": 1
        },
        "tiles": [
          {
            "id": 748,
            "value_a": 6,
            "value_b": 6,
            "position": {
              "x": 0.0,
              "y": 0.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 6,
              "ndir": "right",
              "near_val": 6,
              "far_val": 6,
              "double": false,
              "center": [
                0.0,
                0.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 745,
            "value_a": 6,
            "value_b": 3,
            "position": {
              "x": 0.0,
              "y": -1.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 3,
              "ndir": "down",
              "near_val": 6,
              "far_val": 3,
              "double": false,
              "center": [
                0.0,
                -1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 743,
            "value_a": 6,
            "value_b": 1,
            "position": {
              "x": 0.0,
              "y": 1.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 1,
              "ndir": "up",
              "near_val": 6,
              "far_val": 1,
              "double": false,
              "center": [
                0.0,
                1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 724,
            "value_a": 3,
            "value_b": 3,
            "position": {
              "x": 0.0,
              "y": -3.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 3,
              "b": 3,
              "ndir": "down",
              "near_val": 3,
              "far_val": 3,
              "double": false,
              "center": [
                0.0,
                -3.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 721,
            "value_a": 3,
            "value_b": 0,
            "position": {
              "x": 0.0,
              "y": -4.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 3,
              "b": 0,
              "ndir": "down",
              "near_val": 3,
              "far_val": 0,
              "double": false,
              "center": [
                0.0,
                -4.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 736,
            "value_a": 5,
            "value_b": 1,
            "position": {
              "x": 0.0,
              "y": 3.5,
              "orientation": "vertical",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 5,
              "b": 1,
              "ndir": "up",
              "near_val": 1,
              "far_val": 5,
              "double": false,
              "center": [
                0.0,
                3.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 700,
            "value_a": 0,
            "value_b": 0,
            "position": {
              "x": 0.0,
              "y": -6.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 0,
              "b": 0,
              "ndir": "down",
              "near_val": 0,
              "far_val": 0,
              "double": false,
              "center": [
                0.0,
                -6.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 740,
            "value_a": 5,
            "value_b": 5,
            "position": {
              "x": 0.0,
              "y": 5.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 5,
              "b": 5,
              "ndir": "up",
              "near_val": 5,
              "far_val": 5,
              "double": false,
              "center": [
                0.0,
                5.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          }
        ],
        "board_ends": [],
        "chain_length": 8
      },
      "board_chain_length": 8,
      "players": [
        {
          "id": 101,
          "display_name": "You",
          "country_code": null,
          "avatar_key": null,
          "avatar_url": null,
          "is_bot": false,
          "team": 0,
          "position": 0
        },
        {
          "id": 102,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_1",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 1
        },
        {
          "id": 103,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_2",
          "avatar_url": null,
          "is_bot": true,
          "team": 0,
          "position": 2
        },
        {
          "id": 104,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_3",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 3
        }
      ],
      "hand_counts": {
        "0": 5,
        "1": 5,
        "2": 5,
        "3": 5
      },
      "session_team_scores": {
        "0": 0,
        "1": 0
      },
      "next_round_deadline_at": null,
      "next_round_ready": null,
      "next_game_id": null,
      "session_over": false,
      "session_winner_team": null,
      "session_completion_reason": null,
      "target_score": 100,
      "rematch": null
    }
  ],
  "finalLeft": {
    "id": 9001,
    "state_seq": 9,
    "status": "active",
    "game_mode": "bots",
    "current_turn": 1,
    "current_turn_user_id": 102,
    "current_turn_team": 1,
    "board_left_end": 5,
    "board_right_end": 5,
    "played_tiles": [],
    "my_hand": [
      {
        "id": 730,
        "value_a": 2,
        "value_b": 4,
        "is_double": false,
        "valid_positions": []
      },
      {
        "id": 744,
        "value_a": 2,
        "value_b": 6,
        "is_double": false,
        "valid_positions": []
      },
      {
        "id": 746,
        "value_a": 4,
        "value_b": 6,
        "is_double": false,
        "valid_positions": []
      },
      {
        "id": 716,
        "value_a": 2,
        "value_b": 2,
        "is_double": true,
        "valid_positions": []
      }
    ],
    "my_team": 0,
    "my_position": 0,
    "viewer_cosmetics": {
      "table_skin": "green_fabric",
      "tile_skin": "classic"
    },
    "winner_team": null,
    "game_end_type": null,
    "session_id": 9002,
    "game_number": 1,
    "starting_player_position": 0,
    "starting_player_user_id": 101,
    "board_layout": {
      "board_config": {
        "min_x": -6,
        "max_x": 6,
        "min_y": -7,
        "max_y": 7,
        "tile_width": 2,
        "tile_height": 1
      },
      "tiles": [
        {
          "id": 748,
          "value_a": 6,
          "value_b": 6,
          "position": {
            "x": 0.0,
            "y": 0.0,
            "orientation": "horizontal",
            "connected_side": "a"
          },
          "connected_side": "a",
          "is_double": false,
          "engine_data": {
            "a": 6,
            "b": 6,
            "ndir": "right",
            "near_val": 6,
            "far_val": 6,
            "double": false,
            "center": [
              0.0,
              0.0
            ],
            "horizontal": true,
            "cross_horizontal": false
          }
        },
        {
          "id": 745,
          "value_a": 6,
          "value_b": 3,
          "position": {
            "x": 0.0,
            "y": -1.5,
            "orientation": "vertical",
            "connected_side": "a"
          },
          "connected_side": "a",
          "is_double": false,
          "engine_data": {
            "a": 6,
            "b": 3,
            "ndir": "down",
            "near_val": 6,
            "far_val": 3,
            "double": false,
            "center": [
              0.0,
              -1.5
            ],
            "horizontal": false,
            "cross_horizontal": false
          }
        },
        {
          "id": 743,
          "value_a": 6,
          "value_b": 1,
          "position": {
            "x": 0.0,
            "y": 1.5,
            "orientation": "vertical",
            "connected_side": "a"
          },
          "connected_side": "a",
          "is_double": false,
          "engine_data": {
            "a": 6,
            "b": 1,
            "ndir": "up",
            "near_val": 6,
            "far_val": 1,
            "double": false,
            "center": [
              0.0,
              1.5
            ],
            "horizontal": false,
            "cross_horizontal": false
          }
        },
        {
          "id": 724,
          "value_a": 3,
          "value_b": 3,
          "position": {
            "x": 0.0,
            "y": -3.0,
            "orientation": "horizontal",
            "connected_side": "a"
          },
          "connected_side": "a",
          "is_double": false,
          "engine_data": {
            "a": 3,
            "b": 3,
            "ndir": "down",
            "near_val": 3,
            "far_val": 3,
            "double": false,
            "center": [
              0.0,
              -3.0
            ],
            "horizontal": true,
            "cross_horizontal": false
          }
        },
        {
          "id": 721,
          "value_a": 3,
          "value_b": 0,
          "position": {
            "x": 0.0,
            "y": -4.5,
            "orientation": "vertical",
            "connected_side": "a"
          },
          "connected_side": "a",
          "is_double": false,
          "engine_data": {
            "a": 3,
            "b": 0,
            "ndir": "down",
            "near_val": 3,
            "far_val": 0,
            "double": false,
            "center": [
              0.0,
              -4.5
            ],
            "horizontal": false,
            "cross_horizontal": false
          }
        },
        {
          "id": 736,
          "value_a": 5,
          "value_b": 1,
          "position": {
            "x": 0.0,
            "y": 3.5,
            "orientation": "vertical",
            "connected_side": "b"
          },
          "connected_side": "b",
          "is_double": false,
          "engine_data": {
            "a": 5,
            "b": 1,
            "ndir": "up",
            "near_val": 1,
            "far_val": 5,
            "double": false,
            "center": [
              0.0,
              3.5
            ],
            "horizontal": false,
            "cross_horizontal": false
          }
        },
        {
          "id": 700,
          "value_a": 0,
          "value_b": 0,
          "position": {
            "x": 0.0,
            "y": -6.0,
            "orientation": "horizontal",
            "connected_side": "a"
          },
          "connected_side": "a",
          "is_double": false,
          "engine_data": {
            "a": 0,
            "b": 0,
            "ndir": "down",
            "near_val": 0,
            "far_val": 0,
            "double": false,
            "center": [
              0.0,
              -6.0
            ],
            "horizontal": true,
            "cross_horizontal": false
          }
        },
        {
          "id": 740,
          "value_a": 5,
          "value_b": 5,
          "position": {
            "x": 0.0,
            "y": 5.0,
            "orientation": "horizontal",
            "connected_side": "a"
          },
          "connected_side": "a",
          "is_double": false,
          "engine_data": {
            "a": 5,
            "b": 5,
            "ndir": "up",
            "near_val": 5,
            "far_val": 5,
            "double": false,
            "center": [
              0.0,
              5.0
            ],
            "horizontal": true,
            "cross_horizontal": false
          }
        },
        {
          "id": 735,
          "value_a": 5,
          "value_b": 0,
          "position": {
            "x": -2.0,
            "y": -6.0,
            "orientation": "horizontal",
            "connected_side": "b"
          },
          "connected_side": "b",
          "is_double": false,
          "engine_data": {
            "a": 5,
            "b": 0,
            "ndir": "left",
            "near_val": 0,
            "far_val": 5,
            "double": false,
            "center": [
              -2.0,
              -6.0
            ],
            "horizontal": true,
            "cross_horizontal": false
          }
        }
      ],
      "board_ends": [],
      "chain_length": 9
    },
    "board_chain_length": 9,
    "players": [
      {
        "id": 101,
        "display_name": "You",
        "country_code": null,
        "avatar_key": null,
        "avatar_url": null,
        "is_bot": false,
        "team": 0,
        "position": 0
      },
      {
        "id": 102,
        "display_name": "Bot (Medium)",
        "country_code": null,
        "avatar_key": "avatar_1",
        "avatar_url": null,
        "is_bot": true,
        "team": 1,
        "position": 1
      },
      {
        "id": 103,
        "display_name": "Bot (Medium)",
        "country_code": null,
        "avatar_key": "avatar_2",
        "avatar_url": null,
        "is_bot": true,
        "team": 0,
        "position": 2
      },
      {
        "id": 104,
        "display_name": "Bot (Medium)",
        "country_code": null,
        "avatar_key": "avatar_3",
        "avatar_url": null,
        "is_bot": true,
        "team": 1,
        "position": 3
      }
    ],
    "hand_counts": {
      "0": 4,
      "1": 5,
      "2": 5,
      "3": 5
    },
    "session_team_scores": {
      "0": 0,
      "1": 0
    },
    "next_round_deadline_at": null,
    "next_round_ready": null,
    "next_game_id": null,
    "session_over": false,
    "session_winner_team": null,
    "session_completion_reason": null,
    "target_score": 100,
    "rematch": null
  },
  "finalRight": {
    "id": 9001,
    "state_seq": 9,
    "status": "active",
    "game_mode": "bots",
    "current_turn": 1,
    "current_turn_user_id": 102,
    "current_turn_team": 1,
    "board_left_end": 0,
    "board_right_end": 0,
    "played_tiles": [],
    "my_hand": [
      {
        "id": 730,
        "value_a": 2,
        "value_b": 4,
        "is_double": false,
        "valid_positions": []
      },
      {
        "id": 744,
        "value_a": 2,
        "value_b": 6,
        "is_double": false,
        "valid_positions": []
      },
      {
        "id": 746,
        "value_a": 4,
        "value_b": 6,
        "is_double": false,
        "valid_positions": []
      },
      {
        "id": 716,
        "value_a": 2,
        "value_b": 2,
        "is_double": true,
        "valid_positions": []
      }
    ],
    "my_team": 0,
    "my_position": 0,
    "viewer_cosmetics": {
      "table_skin": "green_fabric",
      "tile_skin": "classic"
    },
    "winner_team": null,
    "game_end_type": null,
    "session_id": 9002,
    "game_number": 1,
    "starting_player_position": 0,
    "starting_player_user_id": 101,
    "board_layout": {
      "board_config": {
        "min_x": -6,
        "max_x": 6,
        "min_y": -7,
        "max_y": 7,
        "tile_width": 2,
        "tile_height": 1
      },
      "tiles": [
        {
          "id": 748,
          "value_a": 6,
          "value_b": 6,
          "position": {
            "x": 0.0,
            "y": 0.0,
            "orientation": "horizontal",
            "connected_side": "a"
          },
          "connected_side": "a",
          "is_double": false,
          "engine_data": {
            "a": 6,
            "b": 6,
            "ndir": "right",
            "near_val": 6,
            "far_val": 6,
            "double": false,
            "center": [
              0.0,
              0.0
            ],
            "horizontal": true,
            "cross_horizontal": false
          }
        },
        {
          "id": 745,
          "value_a": 6,
          "value_b": 3,
          "position": {
            "x": 0.0,
            "y": -1.5,
            "orientation": "vertical",
            "connected_side": "a"
          },
          "connected_side": "a",
          "is_double": false,
          "engine_data": {
            "a": 6,
            "b": 3,
            "ndir": "down",
            "near_val": 6,
            "far_val": 3,
            "double": false,
            "center": [
              0.0,
              -1.5
            ],
            "horizontal": false,
            "cross_horizontal": false
          }
        },
        {
          "id": 743,
          "value_a": 6,
          "value_b": 1,
          "position": {
            "x": 0.0,
            "y": 1.5,
            "orientation": "vertical",
            "connected_side": "a"
          },
          "connected_side": "a",
          "is_double": false,
          "engine_data": {
            "a": 6,
            "b": 1,
            "ndir": "up",
            "near_val": 6,
            "far_val": 1,
            "double": false,
            "center": [
              0.0,
              1.5
            ],
            "horizontal": false,
            "cross_horizontal": false
          }
        },
        {
          "id": 724,
          "value_a": 3,
          "value_b": 3,
          "position": {
            "x": 0.0,
            "y": -3.0,
            "orientation": "horizontal",
            "connected_side": "a"
          },
          "connected_side": "a",
          "is_double": false,
          "engine_data": {
            "a": 3,
            "b": 3,
            "ndir": "down",
            "near_val": 3,
            "far_val": 3,
            "double": false,
            "center": [
              0.0,
              -3.0
            ],
            "horizontal": true,
            "cross_horizontal": false
          }
        },
        {
          "id": 721,
          "value_a": 3,
          "value_b": 0,
          "position": {
            "x": 0.0,
            "y": -4.5,
            "orientation": "vertical",
            "connected_side": "a"
          },
          "connected_side": "a",
          "is_double": false,
          "engine_data": {
            "a": 3,
            "b": 0,
            "ndir": "down",
            "near_val": 3,
            "far_val": 0,
            "double": false,
            "center": [
              0.0,
              -4.5
            ],
            "horizontal": false,
            "cross_horizontal": false
          }
        },
        {
          "id": 736,
          "value_a": 5,
          "value_b": 1,
          "position": {
            "x": 0.0,
            "y": 3.5,
            "orientation": "vertical",
            "connected_side": "b"
          },
          "connected_side": "b",
          "is_double": false,
          "engine_data": {
            "a": 5,
            "b": 1,
            "ndir": "up",
            "near_val": 1,
            "far_val": 5,
            "double": false,
            "center": [
              0.0,
              3.5
            ],
            "horizontal": false,
            "cross_horizontal": false
          }
        },
        {
          "id": 700,
          "value_a": 0,
          "value_b": 0,
          "position": {
            "x": 0.0,
            "y": -6.0,
            "orientation": "horizontal",
            "connected_side": "a"
          },
          "connected_side": "a",
          "is_double": false,
          "engine_data": {
            "a": 0,
            "b": 0,
            "ndir": "down",
            "near_val": 0,
            "far_val": 0,
            "double": false,
            "center": [
              0.0,
              -6.0
            ],
            "horizontal": true,
            "cross_horizontal": false
          }
        },
        {
          "id": 740,
          "value_a": 5,
          "value_b": 5,
          "position": {
            "x": 0.0,
            "y": 5.0,
            "orientation": "horizontal",
            "connected_side": "a"
          },
          "connected_side": "a",
          "is_double": false,
          "engine_data": {
            "a": 5,
            "b": 5,
            "ndir": "up",
            "near_val": 5,
            "far_val": 5,
            "double": false,
            "center": [
              0.0,
              5.0
            ],
            "horizontal": true,
            "cross_horizontal": false
          }
        },
        {
          "id": 735,
          "value_a": 5,
          "value_b": 0,
          "position": {
            "x": -2.0,
            "y": 5.0,
            "orientation": "horizontal",
            "connected_side": "a"
          },
          "connected_side": "a",
          "is_double": false,
          "engine_data": {
            "a": 5,
            "b": 0,
            "ndir": "left",
            "near_val": 5,
            "far_val": 0,
            "double": false,
            "center": [
              -2.0,
              5.0
            ],
            "horizontal": true,
            "cross_horizontal": false
          }
        }
      ],
      "board_ends": [],
      "chain_length": 9
    },
    "board_chain_length": 9,
    "players": [
      {
        "id": 101,
        "display_name": "You",
        "country_code": null,
        "avatar_key": null,
        "avatar_url": null,
        "is_bot": false,
        "team": 0,
        "position": 0
      },
      {
        "id": 102,
        "display_name": "Bot (Medium)",
        "country_code": null,
        "avatar_key": "avatar_1",
        "avatar_url": null,
        "is_bot": true,
        "team": 1,
        "position": 1
      },
      {
        "id": 103,
        "display_name": "Bot (Medium)",
        "country_code": null,
        "avatar_key": "avatar_2",
        "avatar_url": null,
        "is_bot": true,
        "team": 0,
        "position": 2
      },
      {
        "id": 104,
        "display_name": "Bot (Medium)",
        "country_code": null,
        "avatar_key": "avatar_3",
        "avatar_url": null,
        "is_bot": true,
        "team": 1,
        "position": 3
      }
    ],
    "hand_counts": {
      "0": 4,
      "1": 5,
      "2": 5,
      "3": 5
    },
    "session_team_scores": {
      "0": 0,
      "1": 0
    },
    "next_round_deadline_at": null,
    "next_round_ready": null,
    "next_game_id": null,
    "session_over": false,
    "session_winner_team": null,
    "session_completion_reason": null,
    "target_score": 100,
    "rematch": null
  }
};
